<template>
  <LayoutCard class="composite-card-unit">
    <div class="composite-card-unit-img-container">
      <img v-if="node.image_url" :src="node.image_url" />
      <div v-else class="no-image">
        <Boxes :size="64" />
      </div>
    </div>
    <div class="composite-card-unit-body">
      <p class="uptitle composite-card-unit-body-country">{{ node.city }}</p>
      <h3>{{ node.name }}</h3>
      <p v-if="node.city">{{ node.city }}</p>
    </div>
    <RouterLink :to="node_path(node)">
      <CommonButton class="btn-primary regular">
        Voir le détail
        <ArrowRight :size="18" />
      </CommonButton>
    </RouterLink>
    <CommonTag v-if="alerts > 0" classes="blue"> ALERTES ({{ alerts }}) </CommonTag>
  </LayoutCard>
</template>

<script setup lang="ts">
import LayoutCard from '@/components/layout/LayoutCard.vue'
import CommonButton from '../common/CommonButton.vue'
import CommonTag from '../common/CommonTag.vue'
import { ArrowRight, Boxes } from 'lucide-vue-next'
import { onMounted, ref, watch } from 'vue'
import { node_path, type ApplicationTreeNode } from '@/service/service_unit'
import type { ApplicationDevice } from '@/service/service_device'

const alerts = ref<number>(0)
const props = defineProps<{
  node: ApplicationTreeNode
}>()

function get_alerts(): number {
  const devices: ApplicationDevice[] = []
  let output = 0
  devices.forEach((device) => {
    output += device.alerts
  })

  return output
}

watch(
  () => props.node,
  () => {
    alerts.value = get_alerts()
  }
)

onMounted(() => {
  alerts.value = get_alerts()
})
</script>

<style scoped lang="scss">
@import '@/assets/mixins.scss';
@import '@/assets/animations.scss';

.composite-card-unit {
  @include vlayout(20px);

  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  height: 100%;
  position: relative;
  justify-content: space-between;
  animation: moveIn cubic-bezier(0.19, 1, 0.22, 1) 1000ms;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  &-img-container {
    height: 150px;
    border-radius: var(--br-medium);
    overflow: hidden;

    img {
      width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }

  &-body {
    @include vlayout(10px);
    flex: 1;

    &-country {
      letter-spacing: 2px;
    }
  }

  .common-tag {
    position: absolute;
    top: 50px;
    left: 0;
  }
}

.no-image {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: var(--vc-primary);
  opacity: 0.6;
  background-color: var(--vc-gray2);
}
</style>
